import ru from './menu.ru'
import en from './menu.en'
import ro from './menu.ro'

export default {
  ru,
  en,
  ro,
}
